<template>
  <div>
    <div class="head">
      <div class="header-content">
        <div class="web_widht">
          <div class="header_text">
            <div class="plat">
              <div class="diqiu"></div>
              荷塘查策网
            </div>
            <login-nav></login-nav>
          </div>
        </div>
        <div class="logo"></div>
        <div class="search">
          <el-input v-model="searchText" placeholder="请输入内容"></el-input>
          <div class="searchBtn" @click="searchPolicy">搜索</div>
        </div>
        <div class="searchTop">
          <div class="gray">
            <div>热搜榜：</div>
            <div v-for="item in keywordsList" :key="item.id" @click="addKeywords(item)">
              {{ item.keywords }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="tool">
        <div class="tool-item" @click="$router.push('/policy/policyDetail')">
          政策超市
        </div>
        <div class="tool-item" @click="$router.push('/accuratePage/matchPage?status=0')">
          政策匹配
        </div>
        <div
          class="tool-item"
          @click="$router.push({ path: '/policy/policyDetail', query: { status: 5 } })"
        >
          免申即享
        </div>
        <div
          class="tool-item"
          @click="$router.push({ path: '/policy/policyDetail', query: { status: 6 } })"
        >
          活动中心
        </div>
        <div class="tool-item" @click="toAccurate">个人中心</div>
      </div>
      <div class="contont">
        <div class="hotDot">
          <div class="title">
            <div>政策热点</div>
            <div
              class="more"
              style="cursor: pointer"
              @click="
                $router.push({ path: '/policy/policyDetail', query: { status: 1 } })
              "
            >
              更多
            </div>
          </div>
          <div class="itemList">
            <div
              class="item"
              v-for="item in newsList"
              :key="item.id"
              @click="toDetail(item.id, 1)"
            >
              <div class="text">● {{ item.title }}</div>
              <div class="date">{{ item.updateDateTime.split(" ")[0] }}</div>
            </div>
          </div>
        </div>
        <div class="hotDot2">
          <el-carousel height="330px">
            <el-carousel-item v-for="(item, index) in hotDotList" :key="index">
              <div class="img">
                <img :src="item.image" alt="" />
              </div>
              <!-- <div class="bottomText">
                关于举办2023年“创客广东”珠海市中小企业创新创业大赛的通知
              </div> -->
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="home-content">
      <div class="web_widht">
        <div class="list">
          <div
            class="list_item"
            v-for="(item, index) in gridList"
            :key="index"
            @mouseenter="selectNav(index)"
            @click="toPolicy(index)"
            :class="navContentIndex == index ? 'is_active' : ''"
          >
            <div class="imgbox"><img :src="item.icon" alt="" /></div>
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div
        class="nav-content"
        :class="
          navContentIndex == 0
            ? 'nav0'
            : navContentIndex == 1
            ? 'nav1'
            : navContentIndex == 2
            ? 'nav2'
            : 'nav3'
        "
      >
        <div class="table" v-if="navContentIndex == 0">
          <div class="title">
            <div class="one table_head">政策名称</div>
            <div class="two table_head">发文单位</div>
            <div class="three table_head">地区</div>
            <div class="four table_head">发布日期</div>
            <div class="five table_head">状态</div>
          </div>
          <div v-if="policyList.length != 0">
            <div
              class="table-item"
              v-for="(item, index) in policyList"
              :key="item.id"
              :class="index % 2 == 1 ? 'second_table_item' : ''"
              @click="toDetail(item.id, 1)"
              style="cursor: pointer"
            >
              <div class="one table_cell">{{ item.title }}</div>
              <div class="two table_cell">{{ item.dept }}</div>
              <div class="three table_cell">{{ item.area }}</div>
              <div class="four table_cell">
                {{ item.updateDateTime.split(" ")[0].split("-").join(".") }}
              </div>
              <div class="five table_cell">进行中</div>
            </div>
          </div>
          <div v-else style="text-align: center">暂无数据</div>
        </div>
        <div class="table" v-else-if="navContentIndex == 1">
          <div class="title">
            <div class="one table_head">政策名称</div>
            <div class="two table_head">发文单位</div>
            <div class="three table_head">地区</div>
            <div class="four table_head">发布日期</div>
            <div class="five table_head" style="width: 10%">分类</div>
          </div>
          <div v-if="productList.length != 0">
            <div
              class="table-item"
              v-for="(item, index) in productList"
              :key="item.id"
              :class="index % 2 == 1 ? 'second_table_item' : ''"
              @click="toDetail(item.id, 2)"
              style="cursor: pointer"
            >
              <div class="one table_cell">{{ item.title }}</div>
              <div class="two table_cell">{{ item.dept }}</div>
              <div class="three table_cell">{{ item.area }}</div>
              <div class="four table_cell">
                {{ item.updateDateTime.split(" ")[0].split("-").join(".") }}
              </div>
              <div class="five table_cell" style="width: 10%">{{ item.partition }}</div>
            </div>
          </div>
         <div v-else style="text-align: center">暂无数据</div>
        </div>
        <div class="table" v-else-if="navContentIndex == 2">
          <div class="title">
            <div class="one table_head">政策名称</div>
            <div class="two table_head">发文单位</div>
            <div class="four table_head" style="width: 18%">状态</div>
            <div class="five table_head">支持方式</div>
          </div>
          <div v-if="shareList.length != 0">
            <div
              class="table-item"
              v-for="(item, index) in shareList"
              :key="item.id"
              :class="index % 2 == 1 ? 'second_table_item' : ''"
              @click="toDetail(item.id, 5)"
              style="cursor: pointer"
            >
              <div class="one table_cell">{{ item.title }}</div>
              <div class="two table_cell">{{ item.source }}</div>
              <div class="four table_cell" style="width: 18%">{{ item.status_str }}</div>
              <div class="five table_cell">{{ item.cate_name }}</div>
            </div>
          </div>
         <div v-else style="text-align: center">暂无数据</div>
        </div>
        <div class="table" v-else>
          <div class="title">
            <div class="one table_head">活动名称</div>
            <div class="three table_head" style="width: 20%">活动地址</div>
            <div class="four table_head" style="width: 20%">活动时间</div>
            <div class="five table_head" style="width: 20%">活动状态</div>
          </div>
          <div v-if="activityList.length != 0">
            <div
              class="table-item"
              v-for="(item, index) in activityList"
              :key="item.id"
              :class="index % 2 == 1 ? 'second_table_item' : ''"
              @click="toDetail(item.id, 6)"
              style="cursor: pointer"
            >
              <div class="one table_cell">{{ item.title }}</div>
              <div class="three table_cell" style="width: 20%">{{ item.address }}</div>
              <div class="four table_cell" style="width: 20%">
                {{ item.starttime + "~" + item.endtime }}
              </div>
              <div class="five table_cell" style="width: 20%">{{ item.status_str }}</div>
            </div>
          </div>
         <div v-else style="text-align: center">暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBanner,
  getKeywords,
  getPolicyList,
  getProductList,
  getShareList,
  getActivityList,
  getUserInfo,
} from "@/api/index";
import loginNav from "@/components/loginNav.vue";
export default {
  name: "HelloWorld",
  components: { loginNav },
  data() {
    return {
      searchText: "",
      hotDotList: [],
      gridList: [
        { name: "政策文件", icon: require("../../static/home_nav_01.png") },
        { name: "政策产品", icon: require("../../static/home_nav_02.png") },
        { name: "免审即享", icon: require("../../static/home_nav_03.png") },
        { name: "活动中心", icon: require("../../static/home_nav_04.png") },
      ],
      navContentIndex: 0,
      keywordsList: [],
      newsList: [],
      policyList: [],
      productList: [],
      shareList: [],
      activityList: [],
    };
  },
  mounted() {
    this.getBannerFn();
    this.getKeywordsFn();
    this.getNewPolicy();
  },
  methods: {
    getBannerFn() {
      getBanner().then((res) => {
        // console.log(res.data.data);
        this.hotDotList = res.data.data;
      });
    },
    getKeywordsFn() {
      getKeywords({ type: 1 }).then((res) => {
        // console.log(res.data.data);
        this.keywordsList = res.data.data;
      });
    },
    async getNewPolicy() {
      await getPolicyList({
        PageIndex: 1,
        SearchKey: "",
        PageSize: 10,
        Plate: "",
        Area: "RegisterArea_HZDQ_Hunan_ZhuZhouShi",
        Dept: "",
        Isup: "true",
      }).then((res) => {
        // console.log(res.data.rows);
        this.newsList = res.data.rows.splice(0, 5);
        this.policyList = res.data.rows.splice(0, 7);
        this.newsList.forEach((item) => {
          if (item.title.indexOf("】") == -1) {
            item.title = "【" + item.area + "】" + item.title;
          }
        });
      });
      await getProductList({
        PageIndex: 1,
        SearchKey: "",
        PageSize: 10,
        Area: "RegisterArea_HZDQ_Hunan_ZhuZhouShi",
        Dept: "",
        Industries: "",
        Attributes: "",
        Isup: "true",
      }).then((res) => {
        // console.log(res.data.rows);
        this.productList = res.data.rows.splice(0, 7);
      });
      await getShareList({
        keywords: "",
        page: 1,
        pageSize: 10,
        source: "index",
      }).then((res) => {
        // console.log(res.data.data.data);
        this.shareList = res.data.data.data.splice(0, 7);
      });
      await getActivityList({
        page: 1,
        source: "index",
      }).then((res) => {
        // console.log(res.data.data.data);
        this.activityList = res.data.data.data.splice(0, 7);
      });
    },
    addKeywords(opt) {
      // console.log(opt);
      this.searchText = opt.keywords;
      this.searchPolicy();
    },
    selectNav(index) {
      this.navContentIndex = index;
      console.log(this.navContentIndex);
    },
    toPolicy(key) {
      let status;
      if (key == 0) {
        status = 1;
      } else if (key == 1) {
        status = 2;
      } else if (key == 2) {
        status = 5;
      } else if (key == 3) {
        status = 6;
      }
      this.$router.push({ path: "/policy/policyDetail", query: { status } });
    },
    toDetail(id, status) {
      this.$router.push({ path: "/detail", query: { id, status } });
    },
    toRegister() {
      this.$router.push({ path: "/registerPage" });
    },
    toAccurate() {
      getUserInfo({
        token: localStorage.getItem("token"),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 3) {
          this.$message.error(res.data.msg);
          setTimeout(() => {
            this.$router.push("/login");
          }, 200);
        } else if (res.data.code == 1) {
          this.$router.push({ path: "/accuratePage" });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    searchPolicy() {
      this.$router.push({
        path: "/policy/policyDetail",
        query: { search: this.searchText, isSearch: true },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.head {
  .header-content {
    width: 100%;
    height: 485px;
    text-align: center;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    background-image: url("../../static/header-bg.png");

    .web_widht {
      width: 1200px;
      margin: 0 auto;

      .header_text {
        padding: 15px 0 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;

        .plat {
          .diqiu {
            width: 18px;
            height: 18px;
            display: inline-block;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url("../../static/diqiu.png");
            vertical-align: middle;
          }
        }
      }
    }
  }

  .logo {
    width: 210px;
    height: 100px;
    margin: 20px auto;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../static/qi_logo.png");
  }

  .search {
    background: hsla(0, 0%, 88.2%, 0.62);
    width: 560px;
    height: 40px;
    margin: 20px auto;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    border-radius: 5px;

    ::v-deep .el-input__inner {
      background-color: transparent !important;
      color: #606266 !important;
      border: none;
    }

    ::v-deep .el-input__inner::placeholder {
      color: #606266;
    }

    .searchBtn {
      width: 100px;
      height: 40px;
      background-color: #409eff;
      text-align: center;
      line-height: 40px;
      color: #fff;
      border-radius: 0 5px 5px 0;
      cursor: pointer;
    }
  }

  .searchTop {
    width: 560px;
    height: 24px;
    margin: 20px auto;

    .gray {
      width: 475px;
      height: 24px;
      border-radius: 20px;
      background: rgba(0, 0, 0, 0.32);
      padding: 0 5px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #fff;
      div {
        margin: 0 5px;
        cursor: pointer;
      }
      div:first-child {
        cursor: initial;
      }
      div:hover {
        color: #50a0eb;
      }
      div:first-child:hover {
        color: #fff;
      }
    }
  }
}

.main {
  width: 100%;
  height: 458px;
  background-image: url("../../static/main_bg.png");
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
  margin-top: -92px;
  padding-bottom: 50px;
  padding-top: 34px;
  box-sizing: border-box;

  .tool {
    width: 1240px;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    box-sizing: border-box;
    padding-right: 630px;
    .tool-item {
      position: relative;
      cursor: pointer;
    }
    .tool-item:hover::before {
      content: "";
      display: inline-block;
      position: absolute;
      left: 0;
      right: 0;
      height: 2px;
      background: #fcc91f;
      bottom: -5px;
    }

    .tool-item:hover::after {
      content: "";
      display: inline-block;
      width: 0;
      height: 0;
      border-top: 5px solid #fcc91f;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      bottom: -8px;
      left: calc(50% - 5px);
      position: absolute;
    }
  }

  .contont {
    width: 1240px;
    height: 330px;
    margin: 40px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: start;
  }

  .hotDot {
    width: 610px;
    height: 330px;
    background: #3b85ca;

    .title {
      padding: 15px;
      width: 100%;
      height: 54px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      font-size: 16px;
      font-weight: 700;

      .more {
        font-weight: normal;
      }
    }

    .itemList {
      padding: 0 15px;
      width: 100%;
      height: 276px;
      box-sizing: border-box;
      .item :hover {
        opacity: 0.7;
        transition: all 0.3s linear 0s;
      }

      .item {
        width: 100%;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #fff;
        border-bottom: 1px solid #5c9ad3;
        font-size: 16px;
        cursor: pointer;
        .text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          text-align: start;
          margin-right: 20px;
        }
      }
    }
  }

  .hotDot2 {
    width: 610px;
    height: 330px;

    .img {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .bottomText {
      background-color: rgba(0, 0, 0, 0.3686274509803922);
      color: #fff;
      position: absolute;
      bottom: 0;
      display: block;
      text-align: left;
      padding: 0 15px;
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 50px;
      line-height: 40px;
    }
  }
}

.home-content {
  background-image: url("../../static/home_content_bg.png");
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  padding: 50px 0;

  .web_widht {
    width: 1200px;
    margin: 0 auto;

    .list {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .list_item {
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        align-items: center;
        width: 16.66%;
        height: 173px;
        padding: 20px;
        box-sizing: border-box;
        border: 3px solid #fff;
        box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.08);
        cursor: pointer;
        .imgbox {
          width: 60px;
          height: 60px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .list_item:hover,
      .is_active {
        border: 3px solid #50a0eb;
        box-shadow: 0 0 10px 4px #d7ecfe;
      }
    }
  }
  .nav-content::before {
    width: 26px;
    height: 27px;
    background: #fff;
    border-top: 3px solid #50a0eb;
    border-left: 3px solid #50a0eb;
    display: none;
    position: absolute;
    left: 6%;
    top: 0;
    transform: translateY(-56%) rotate(46deg);

    content: "";
  }
  .nav0::before {
    display: block;
    position: absolute;
    left: 6%;
  }

  .nav1::before {
    display: block;
    left: 36%;
  }

  .nav2::before {
    display: block;
    left: 63%;
  }

  .nav3::before {
    display: block;
    left: 91%;
  }

  .nav-content {
    width: 1200px;
    margin: 50px auto 0;
    height: 406px;
    border: 3px solid #50a0eb;
    position: relative;
    min-height: 350px;
    background: #fff;
    box-sizing: border-box;

    .title {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      box-sizing: border-box;
    }

    .table {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .table_head {
        width: 18%;
        color: #409eff;
        font-weight: 600;
      }
      .table_cell {
        width: 18%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &-item {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .one {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: start;
      }
      .two {
        width: 20%;
      }
      .three,
      .four {
        width: 10%;
      }
      .five {
        width: 5%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .second_table_item {
        background: rgba(215, 236, 254, 0.357);
      }
      &-item:hover {
        background: rgba(215, 236, 254, 0.2);
      }
    }
  }
}
</style>
